import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import CommonTemplate from "templates/common-template"
import SingleColumn from "components/pages/singleColumn"
import TeamList from "components/lists/teams-list"
import GetHelp from "components/get-help"

// markup
const IndexPage = ({ location }) => {
    const data = useStaticQuery(query)
    const { pageData, posts } = data
    const { category } = pageData

    const breadcrums = [category.subtitle || category.name]

    const contents = pageData.content.map((content, index) => {
        let html = null
        if (
            content.Single_Column !== undefined &&
            content.Single_Column !== null
        ) {
            html = (
                <SingleColumn
                    data={content.Single_Column}
                    key={index}
                    className={"content-margin"}
                />
            )
        }
        return html
    })

    const customJsx = (
        <>
            {contents}
            <TeamList url={location.pathname} data={posts.teammembers} />
            <GetHelp />
        </>
    )

    const arrData = {
        location,
        data,
        customElement: customJsx,
        onlyCustom: "partial",
        breadcrums, // allow null
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

const query = graphql`
    {
        pageData: strapiPage(slug: { eq: "wns-our-teams" }) {
            title
            menu_title
            description
            summary
            image {
                childImageSharp {
                    gatsbyImageData(placeholder: BLURRED, width: 230)
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            banner: image {
                childImageSharp {
                    gatsbyImageData(placeholder: BLURRED)
                }
            }
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
            }
        }
        posts: strapiTeam(slug: { eq: "wns-our-teams" }) {
            strapiId
            name
            slug
            description
            teammembers {
                slug
                name
                title
                description
                short_intro
                image {
                    childImageSharp {
                        gatsbyImageData(
                            placeholder: BLURRED
                            width: 300
                            height: 300
                        )
                        id
                    }
                }
            }
        }
    }
`
